import axiosInstance from './axiosInstance';
import { variables } from './variables.js';
import { debounce } from '../debounce';

const API_URL = variables.CART_API;

export const fetchCart = async (customerId, userId) => {
  try {
    return await axiosInstance.get(`${API_URL}/${userId}/${customerId}`);
    
  } catch (error) {
    return { error: error.response?.data || error.message };
  }
};

export const addOrUpdateCart = async (customerId, userId, kits = [], items = [], invoices = [], groupItems=[]) => {
  try {
    return await axiosInstance.post(`${API_URL}/AddOrUpdateCart/add/product`, {
      customerId: customerId,
      userId: userId,
      Kits: kits,
      Items: items,
      Invoices: invoices,
      GroupItems: groupItems,
    });
  } catch (error) {
    return { error: error.response?.data || error.message };
  }
};

export const UpdateCart = async (customerId, userId, kits = [], items = [], invoices = [], groupItems=[], operationType) => {
  try {
    return await axiosInstance.post(`${API_URL}/AddOrUpdateCart/${operationType}/quantity`, {
      customerId: customerId,
      userId: userId,
      Kits: kits,
      Items: items,
      Invoices: invoices,
      GroupItems: groupItems
    });
  } catch (error) {
    return { error: error.response?.data || error.message };
  }
};

export const removeFromCart = async (customerId, userId, kits = [], items = [], invoices = [], groupItems = []) => {
  try {
    return await axiosInstance.post(`${API_URL}/AddOrUpdateCart/remove/product`, {
      customerId: customerId,
      userId: userId,
      Kits: kits,
      Items: items,
      Invoices: invoices,
      GroupItems: groupItems
    });
  } catch (error) {
    return { error: error.response?.data || error.message };
  }
};

export const clearCart = async (customerId, userId) => {
  try {
    return await axiosInstance.delete(`${API_URL}/ClearCart/${customerId}/${userId}`);
  } catch (error) {
    return { error: error.response?.data || error.message };
  }
};

// Debounced versions (300ms delay, adjust as needed)
export const debouncedAddOrUpdateCart = debounce(addOrUpdateCart, 0);
export const debouncedUpdateCart = debounce(UpdateCart, 0);
export const debouncedRemoveFromCart = debounce(removeFromCart, 0);
export const debouncedfetchCart = debounce(fetchCart, 0);